import React from 'react';
import SimpleCell from '@/components/table/SimpleCell';

const VocabularyTextCell = ({ vocabulary }) => (
  <SimpleCell className="td-description" content={vocabulary.value} />
);

export default VocabularyTextCell;
